// extracted by mini-css-extract-plugin
export default {"caixona":"p1_caixona__ytb6H","caixa":"p1_caixa__4s2TH"};